import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { AppConfig, JWT } from '../config';
import { CTSegmentation } from '../config/RayCodes';
import { DoDB } from '../lib/ddb';
import { AlertAction } from './AlertAction';
import { getParents } from '../lib/companyHierarchyService';
import { isRootCompany } from '../lib/licenseHelper';
import { queryDealerAllocationByDealerId } from '../lib/smartDentQueries';
import { LicenseConstant, LicenseIds } from './constants/LicenseConstant';
import { TranslateConstant } from './constants/TranslateConstant';
import { resolveCurrentLangCode } from '../config/currentLang';

const RG_RELU_API = 'https://3jwja9uhsf.execute-api.ap-northeast-2.amazonaws.com/production/license/rt';

const Create = (data) => async (dispatch) => {
  const ret = await axios.post(AppConfig.API_SERVER_PATH + "/translate", {
    type: "regist",
    data,
    who: JSON.parse(localStorage.getItem('user')).adminid
  }, JWT());

  if (ret.data.status == 'success') {
    dispatch({ type: TranslateConstant.REGIST_TRANSLATE_DATA, translate: ret.data.data });
  } else {
    dispatch(AlertAction.Error(ret.data));
  }
}

const Modify = (data) => async (dispatch) => {
  const adminId = JSON.parse(localStorage.getItem('user')).adminid;
  const ret = await axios.post(AppConfig.API_SERVER_PATH + "/translate", { type: 'modify', data, who: adminId }, JWT());

  if (ret.data.status == 'success') {
    dispatch({ type: TranslateConstant.MODIFY_TRANSLATE_DATA, translate: ret.data.data });
  } else {
    dispatch(AlertAction.Error(ret.data));
  }
}
//const GetRecord = async (data) => {
const GetLicenseBySN = async (sn) => {
  try {
    const payload = {
      type: "query",
      region: "ap-northeast-2",
      params: {
        TableName: "rayteams-license",
        IndexName: "sn-sk-index",
        KeyConditionExpression: "#sn = :sn and begins_with(#sk, :sk)",
        ExpressionAttributeNames: { "#sn": "sn", "#sk": "sk" },
        ExpressionAttributeValues: { ":sn": sn, ":sk": "lcuse:" },
      },
    };
    const list = await DoDB(payload.type, payload.params, payload.region);
    return list ?? [];
  } catch (error) {
    return [];
  }
}

const GetManagerGroupInfoByCompanyId = async (companyId, appId) => {
  try {
    const payload = {
      type: "scan",
      region: "ap-northeast-2",
      params: {
        TableName: "rayteams-manager-group",
        FilterExpression: "contains(#companyIds, :companyIds)",
        ExpressionAttributeNames: { "#companyIds": "companyIds" },
        ExpressionAttributeValues: { ":companyIds": companyId },
      },
    };
    const list = await DoDB(payload.type, payload.params, payload.region);
    if(list.length > 0) {
      const ret = await GetManagerGroupLicenseType(appId, list[0]._id);
      return ret;
    }
    return [];
  } catch (error) {
    return [];
  }
}
//const Modify = (data) => async (dispatch) => {
const GetLicenseByCompanyId = (companyId) => async (dispatch, getState) => {
  try {
    const licenseList = [];
    const payload = {
      type: "scan",
      region: "ap-northeast-2",
      params: {
        TableName: "rayteams-manager-group",
        FilterExpression: "contains(#companyIds, :companyIds)",
        ExpressionAttributeNames: { "#companyIds": "companyIds" },
        ExpressionAttributeValues: { ":companyIds": companyId },
      },
    };
    const list = await DoDB(payload.type, payload.params, payload.region);

    if(list.length > 0) {
      for(const item of LicenseIds) {
        const ret = await GetManagerGroupLicenseType(item.id, list[0]._id);
        if(ret?._id) {
          licenseList.push(ret);
        }
      }
      dispatch({ type: LicenseConstant.GET_LICENSE_BY_COMPANY_ID, licenses: licenseList });
      return licenseList;
    } else {
      // BUG-183: 중간 법인(mg-null)은 자기 manager-group 이 없어 corp-ledger 모델 앱(App-SmartDentFiveD/App-FaceAnalyzer)을
      // 소유하지 않는다. 따라서 received(smartdent_standalone)만 표시하고, 나머지 LicenseIds 에 대한 조상 조회는
      // 의도적으로 생략한다(조상 값 노출 방지 — BUG-177 "각 조직 자기 것만" 원칙). received 가 없을 때만 아래 ancestor 폴백으로 진행.
      //
      // PR #497 리뷰(Major): received-first(임의 companyId 조회 가능한 queryDealerAllocationByDealerId)는
      // 본인 companyId 조회에만 허용 — 형제 호출부(SmartDentAction GetMyDealerAllocation 등)와 동일 actor 가드.
      const actor = getState?.()?.AuthReducer?.user ?? null;
      if (actor?.companyId === companyId) {
        // 중간 법인(mg-null)은 조상 corp 원장이 아니라 자기가 받은 레코드(info:{parentMg}:{self})를 예산 원천으로 사용.
        // BUG-211 R3(리뷰 Architecture Major): LicenseOverviewTab 마운트가 이 호출과
        // SmartDentAction.GetMyDealerAllocation 을 같은 companyId 로 함께 dispatch 한다 —
        // dedupe:true 로 두 스캔이 공유하도록 배선(형제 호출부와 동일 opt-in).
        const received = await queryDealerAllocationByDealerId(companyId, { dedupe: true });
        if (received?._id) {
          licenseList.push(received);
          dispatch({ type: LicenseConstant.GET_LICENSE_BY_COMPANY_ID, licenses: licenseList });
          return licenseList;
        }
      } else {
        console.warn('[guard] GetLicenseByCompanyId received-first skipped — actor≠target', {
          handler: 'LicenseAction.GetLicenseByCompanyId',
          actorCompanyId: actor?.companyId ?? null,
          targetCompanyId: companyId,
          reason: 'received-first is self-only (avoid cross-tenant received lookup)',
        });
      }

      // companyId 가 branch 인지 확인 하고 branch 가 아닌 경우 해당 companyId 로 parentCompanyId
      const parentCompanyId = await getParents();
      if (parentCompanyId.length === 1 && parentCompanyId[0].code === companyId) {
        companyId = companyId;
      } else {
        companyId = parentCompanyId.find(x => x.code !== companyId && x?.org === "Branch" && isRootCompany(x))?.code;
      }

      // Branch fallback 미매칭 시 companyId 가 undefined → DoDB 500 회피 (딜러 로그인 시).
      if (!companyId) {
        dispatch({ type: LicenseConstant.GET_LICENSE_BY_COMPANY_ID, licenses: [] });
        return [];
      }

      const payload = {
        type: "scan",
        region: "ap-northeast-2",
        params: {
          TableName: "rayteams-manager-group",
          FilterExpression: "contains(#companyIds, :companyIds)",
          ExpressionAttributeNames: { "#companyIds": "companyIds" },
          ExpressionAttributeValues: { ":companyIds": companyId },
        },
      };
      const list = await DoDB(payload.type, payload.params, payload.region);

      if(list.length > 0) {
        for(const item of LicenseIds) {
          const ret = await GetManagerGroupLicenseType(item.id, list[0]._id);
          if(ret?._id) {
            licenseList.push(ret);
          }
        }
        dispatch({ type: LicenseConstant.GET_LICENSE_BY_COMPANY_ID, licenses: licenseList });
        return licenseList;
    } else {
      dispatch({ type: LicenseConstant.GET_LICENSE_BY_COMPANY_ID, licenses: [] });
      return [];
    }
    }
  } catch (error) {
    return [];
  }
};

const GetManagerGroupLicenseType = async (appId, managerGroupId) => {
  try {
    const payload = {
      type: "query",
      region: "ap-northeast-2",
      params: {
        TableName: "rayteams-license",
        KeyConditionExpression: "#_id = :_id and #sk = :sk",
        ExpressionAttributeNames: { "#_id": "_id", "#sk": "sk" },
        ExpressionAttributeValues: { ":_id": appId, ":sk": `info:${managerGroupId}` },
      },
    };
    const list = await DoDB(payload.type, payload.params, payload.region);
    return list[0] ?? [];
  } catch (error) {
    return [];
  }
};

const GetAll = () => async (dispatch) => {
  try {
    const ret = await axios.get(AppConfig.API_SERVER_PATH + "/translate", JWT());
    if (ret.data.status == 'success') {
      dispatch({ type: TranslateConstant.GET_TRANSLATE_DATA, translate: ret.data.data });
    }
    else
      dispatch(AlertAction.Error(ret.data));
  } catch (error) {
    // IMP-091 §7: silent-error 가드
    console.warn('[LicenseAction.GetAll] failed', {
      handler: 'LicenseAction.GetAll',
      reason: error?.message || String(error),
    });
    dispatch(AlertAction.ErrorMsg("Failed to load translations"));
  }
}

const SearchByLanguageDirect = async (language) => {
  const aggregate = [];
	aggregate.push({ '$match' : { isDel: false, language: language } });
	aggregate.push({
		'$project': {
            _id : 0,
			title: 1,
			language: 1,
			contents: 1
		}
	});
	const data = {
		data : {
			type: "translates",
      passfilter: true,
			aggregate,
		}
	}
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/q', data, JWT());
		//const ret = await axios.get(AppConfig.API_SERVER_PATH + "/translate/" + language);
		if (ret.data.status == 'success')
			return ret.data.data;
		return [];
	} catch (error) {
		console.warn('[LicenseAction.SearchByLanguageDirect] failed', {
			handler: 'LicenseAction.SearchByLanguageDirect',
			target: language,
			reason: error?.message || String(error),
		});
		return [];
	}
}

const SearchByLanguage = () => async (dispatch) => {
    try {
        const language = resolveCurrentLangCode();
        if (!language) {
            console.warn('[LicenseAction.SearchByLanguage] skipped', {
                handler: 'LicenseAction.SearchByLanguage',
                reason: 'current language could not be resolved',
            });
            return;
        }

        const ret = await axios.get(AppConfig.API_SERVER_PATH + "/translate/" + language);
        if (ret.data.status == 'success') {
            dispatch({ type: TranslateConstant.SEARCH_TRANSLATE_DATA, translate: ret.data.data });
        } else {
            dispatch(AlertAction.Error(ret.data));
        }
    } catch (error) {
        console.warn('[LicenseAction.SearchByLanguage] failed', {
            handler: 'LicenseAction.SearchByLanguage',
            reason: error?.message || String(error),
        });
        dispatch(AlertAction.ErrorMsg("Failed to load translations"));
    }
}

const CheckFireStoreSN = async (sn) => {
    try {
        const ret = await axios.post(AppConfig.API_FIRESTORE_PATH + "/devices:runQuery", {
            where: {
                fieldFilter: {
                    field: {
                        fieldPath: "sn"
                    },
                    op: "EQUAL",
                    value: {
                        "stringValue": sn
                    }
                }
            }
        }, {
            headers: {
                "rt-client-data" : "eyJjbGllbnRJZCI6ICJOb25lIiwgImNsaWVudFR5cGUiOiAid2ViLXJheWd1YXJkIiwgImNvZGUiOiAic3RvcmUtYXBpIn0="
            }
        });
        const items = ret.data?.filter(a => !!a.document);
        return items?.[0]?.document?.fields;
    } catch (error) {
        console.warn('[LicenseAction.CheckFireStoreSN] failed', { handler: 'LicenseAction.CheckFireStoreSN', target: sn, reason: error?.message || String(error) });
        return undefined;
    }
}

const UpdateFireStoreTask = async (data) => {
    try {
        const ret = await axios.post(AppConfig.API_FIRESTORE_PATH + "/tasks/" + data?.fields?._id, {
            "fields": data?.fields
        }, {
            headers: {
                "rt-client-data" : "eyJjbGllbnRJZCI6ICJOb25lIiwgImNsaWVudFR5cGUiOiAid2ViLXJheWd1YXJkIiwgImNvZGUiOiAic3RvcmUtYXBpIn0="
            }
        });
        return ret.data;
    } catch (error) {
        console.warn('[LicenseAction.UpdateFireStoreTask] failed', { handler: 'LicenseAction.UpdateFireStoreTask', target: data?.fields?._id, reason: error?.message || String(error) });
        return null;
    }
}

const UpdateLicenseCount = async (data) => {
    const updateParams = {
        TableName: "rayteams-license",
        Key: {
            _id: data.appid,
            sk: `info:${data.mgroupid}`,
        },
        UpdateExpression: "SET #used = if_not_exists(#used, :initial) + :num",
        ExpressionAttributeNames: {
            "#used": "u_package",
        },
        ExpressionAttributeValues: {
            ":initial": 0,
            ":num": 1
        }
    }
    const ret = await DoDB("update",updateParams);
    return ret;
};

const GetLicenseSN = async (data) => {
    const payload = {
        type: "query",
        region: "ap-northeast-2",
        params: {
            TableName: "rayteams-license",
            IndexName: "sn-sk-index",
            KeyConditionExpression: "#sn = :sn",
            ExpressionAttributeNames: { "#sn": "sn" },
            ExpressionAttributeValues: { ":sn": data.sn },
        },
    };
    const list = await DoDB(payload.type, payload.params, payload.region);
    // expired 값을 기준으로 내림차순 정렬하고 첫번째 항목만 선택
    // expired가 가장 큰(최신) 라이센스를 가져오기 위함
    //list = list.sort((a, b) => b.expired - a.expired).slice(0, 1)[0];
    if(list[0]) {
        if(list[0]._id === CTSegmentation.appId) {
            const reluInfo = await GetReluLicenseInfo(data);
            if(reluInfo?._id) {
                list[0].licenseType = reluInfo?.sk.split(':')[1];
                list[0].period = reluInfo?.period || 0;
                list[0].pre_renewal_period = reluInfo?.pre_renewal_period || 0;
            } else {
                list[0].licenseType = "package";
                list[0].period = 365;
                list[0].pre_renewal_period = 0;
            }
        }

        list[0].b2b = "ray",
        list[0].appName = list[0]._id,
        list[0].userId = list[0]?.userid,
        list[0].groupId = list[0]?.groupid

        if(list[0]?.expired < Date.now()) {
            list[0].check = false;
        } else {
            list[0].check = true;
        }
    }

    return list[0] ?? [];
};

const GetALLLicenseSN = async (data) => {
    const payload = {
        type: "query",
        region: "ap-northeast-2",
        params: {
            TableName: "rayteams-license",
            IndexName: "sn-sk-index",
            KeyConditionExpression: "#sn = :sn",
            ExpressionAttributeNames: { "#sn": "sn" },
            ExpressionAttributeValues: { ":sn": data.sn },
        },
    };
    const list = await DoDB(payload.type, payload.params, payload.region);
    // expired 값을 기준으로 내림차순 정렬하고 첫번째 항목만 선택
    // expired가 가장 큰(최신) 라이센스를 가져오기 위함
    //list = list.sort((a, b) => b.expired - a.expired).slice(0, 1)[0];
    return list ?? [];
};

const UpdateLicenseSN = async (data) => {
    const updateParams = {
        TableName: "rayteams-license",
        Key: {
            _id: data._id,
            sk: data.sk,
        },
        UpdateExpression: "SET #sn = :sn, #ntid = :ntid, #userid = :userid, #groupid = :groupid",
        ExpressionAttributeNames: {
            "#sn": "sn",
            "#ntid": "ntid",
            "#userid": "userid",
            "#groupid": "groupid"
        },
        ExpressionAttributeValues: {
            ":sn": "expired",
            ":ntid": "tempntid",
            ":userid": "tempuser",
            ":groupid": "tempgroup"
        }
    }
    const ret = await DoDB("update",updateParams);
    return ret;
};

const CreateReluLicenseSN = async (data, product) => {
    try {
        const ret = await axios.post(RG_RELU_API + `/${data.userId}/${data.sn}`, {});
        const reluLicenseInfo = await GetReluLicenseInfo(product);
        const licenseType = "package";
        const lcInfo = ret.data;
        const MAX_TIME_STAMP = 99999999999999;
        const expired = Date.now() + 1000 * 60 * 60 * 24 * reluLicenseInfo?.period;
        if(lcInfo?.data) {
            const Item = {
                _id: "App-CTSegmentation",
                sk: `pl:${licenseType}:${uuidv4()}`,
                lckey: lcInfo.data.relu_license_key.replace(".", " "),
                deadline: MAX_TIME_STAMP,
                expired: expired,
                period: reluLicenseInfo?.period,
                used: `${"tempuser"}:${"tempgroup"}`,
                template: lcInfo.data?.template,
                relu_license_id: lcInfo.data?.id,
                created: Date.now(),
                assigned: Date.now()
            };
            const createPlParams = {
                TableName: "rayteams-license",
                Key: {
                    _id: Item._id,
                    sk: Item.sk
                },
                UpdateExpression: "SET #assigned = :assigned, #deadline = :deadline, #created = :created, #lckey = :lckey, #period = :period, #used = :used, #relu_license_id = :relu_license_id, #template = :template",
                ExpressionAttributeNames: {
                    "#assigned": "assigned",
                    "#deadline": "deadline",
                    "#created": "created",
                    "#lckey": "lckey",
                    "#period": "period",
                    "#used": "used",
                    "#relu_license_id": "relu_license_id",
                    "#template": "template"
                },
                ExpressionAttributeValues: {
                    ":assigned": Item.assigned,
                    ":created": Item.created,
                    ":deadline": Item.deadline,
                    ":lckey": Item.lckey,
                    ":period": Item.period,
                    ":used": Item.used,
                    ":relu_license_id": Item.relu_license_id,
                    ":template": Item.template
                }
            }
            await DoDB("update",createPlParams);
            const plKey = Item.lckey.replace(".", " ");
            const createLcuseParams = {
                TableName: "rayteams-license",
                Key: {
                    _id: Item._id,
                    sk: 'lcuse:' + data.sn + ':' + "tempgroup" + ':' + "tempuser" + ":" + Item?.sk?.replace("pl:", ""),
                },
                UpdateExpression: "SET #created = :created, #creator = :creator,  #expired = :expired, #lckey = :lckey, #pid = :pid, #reason = :reason, #sn = :sn, #groupid = :groupid, #ntid = :ntid, #mgroupid = :mgroupid, #userid = :userid, #relu_license_id = :relu_license_id",
                ExpressionAttributeNames: {
                    "#created": "created",
                    "#creator": "creator",
                    "#expired": "expired",
                    "#lckey": "lckey",
                    "#pid": "pid",
                    "#reason": "reason",
                    "#sn": "sn" ,
                    "#groupid": "groupid",
                    "#ntid": "ntid",
                    "#mgroupid": "mgroupid",
                    "#userid": "userid",
                    "#relu_license_id": "relu_license_id"
                },
                ExpressionAttributeValues: {
                    ":created": Date.now(),
                    ":creator": data.userId,
                    ":expired": expired,
                    ":lckey": plKey,
                    ":pid": data.pid,
                    ":reason": "rayguard",
                    ":sn": data.sn,
                    ":groupid": data.groupId,
                    ":ntid": "tempntid",
                    ":mgroupid": data.mgroupid || "tempgroupid",
                    ":userid": data.userId,
                    ":relu_license_id": Item.relu_license_id
                }
            }
            const lcRet = await DoDB("update",createLcuseParams);
            return lcRet;
        }
        return null;
    } catch (error) {
        console.error('[LicenseAction.CreateReluLicenseSN] failed', { handler: 'LicenseAction.CreateReluLicenseSN', target: data?.sn, reason: error?.message || String(error) });
        return null;
    }
};

const ChangeLicenseSN = async (data, newData) => {
    const newSk = data.sk.replace(/lcuse:(.*?):/, `lcuse:${newData.sn}:`);
    const date = Date.now();

    let updateExp = "SET #updated = :updated, #updater = :updater, #created = :created, #creator = :creator,  #expired = :expired, #lckey = :lckey, #pid = :pid, #reason = :reason, #sn = :sn, #groupid = :groupid, #ntid = :ntid, #mgroupid = :mgroupid, #userid = :userid, #activated = :activated";
    const expNames = {
        "#updated": "updated",
        "#updater": "updater",
        "#created": "created",
        "#creator": "creator",
        "#expired": "expired",
        "#lckey": "lckey",
        "#pid": "pid",
        "#reason": "reason",
        "#sn": "sn",
        "#groupid": "groupid",
        "#ntid": "ntid",
        "#mgroupid": "mgroupid",
        "#userid": "userid",
        "#activated": "activated"
    };
    const expValues = {
        ":updated": date,
        ":updater": localStorage.getItem("user")?.userid || "5di",
        ":created": date,
        ":creator": data.userId || data?.userid || "5di",
        ":expired": data.expired,
        ":lckey": data.lckey,
        ":pid": data.pid,
        ":reason": `${data.reason} - ${newData.reason}`,
        ":sn": newData.sn,
        ":groupid": data?.groupId || data?.groupid || "tempgroup",
        ":ntid": data?.ntid || "tempntid",
        ":mgroupid": data?.mgroupid || "tempmgroupid",
        ":userid": data?.userId || data?.userid || "tempuser",
        ":activated": data?.activated || date
    };

    if (data._id === "App-CTSegmentation") {
        updateExp += ", #relu_license_id = :relu_license_id";
        expNames["#relu_license_id"] = "relu_license_id";
        expValues[":relu_license_id"] = data?.relu_license_id || "";
    }

    const createLcuseParams = {
        TableName: "rayteams-license",
        Key: {
            _id: data._id,
            sk: newSk,
        },
        UpdateExpression: updateExp,
        ExpressionAttributeNames: expNames,
        ExpressionAttributeValues: expValues
    }
    await DoDB("update",createLcuseParams);
    await UpdateLicenseSN(data);
    return createLcuseParams;
};

const CreateLicenseSN = async (data) => {
    const plKey = uuidv4();
	const sk = 'pl:' + 'package' + ':' + plKey;
    const createPlParams = {
        TableName: "rayteams-license",
        Key: {
            _id: data.appId,
            sk: sk
        },
        UpdateExpression: "SET #assigned = :assigned, #deadline = :deadline, #created = :created, #lckey = :lckey, #period = :period, #used = :used",
        ExpressionAttributeNames: {
            "#assigned": "assigned",
            "#deadline": "deadline",
            "#created": "created",
            "#lckey": "lckey",
            "#period": "period",
            "#used": "used"
        },
        ExpressionAttributeValues: {
            ":assigned": Date.now(),
            ":created": Date.now(),
            ":deadline": 99999999999999,
            ":lckey": plKey,
            ":period": 3650,
            ":used": `${data?.groupId || ""}:${data?.userId || ""}`
        }
    }
    await DoDB("update",createPlParams);
    //const expired = Date.now() + 1000 * 60 * 60 * 24 * 3650;
    const expired = data.appId === "App-FaceAnalyzer" ? 99999999999999 : Date.now() + 1000 * 60 * 60 * 24 * 365;
    const createLcuseParams = {
        TableName: "rayteams-license",
        Key: {
            _id: data.appId,
            sk: 'lcuse:' + data.sn + ':' + data.groupId + ':' + data.userId + ":" + sk?.replace("pl:", ""),
        },
        UpdateExpression: "SET #created = :created, #creator = :creator,  #expired = :expired, #lckey = :lckey, #pid = :pid, #reason = :reason, #sn = :sn, #groupid = :groupid, #ntid = :ntid, #mgroupid = :mgroupid, #userid = :userid",
        ExpressionAttributeNames: {
            "#created": "created",
            "#creator": "creator",
            "#expired": "expired",
            "#lckey": "lckey",
            "#pid": "pid",
            "#reason": "reason",
            "#sn": "sn" ,
            "#groupid": "groupid",
            "#ntid": "ntid",
            "#mgroupid": "mgroupid",
            "#userid": "userid"
        },
        ExpressionAttributeValues: {
            ":created": Date.now(),
            ":creator": data.userId,
            ":expired": expired,
            ":lckey": plKey,
            ":pid": data.pid,
            ":reason": "rayguard",
            ":sn": data.sn,
            ":groupid": data.groupId,
            ":ntid": data?.ntid || "tempntid",
            ":mgroupid": data.mgroupid || "tempmgroupid",
            ":userid": data.userId
        }
    }
    const lcRet = await DoDB("update",createLcuseParams);
    return lcRet;
};


const GetReluLicenseInfo = async (data) => {
    const sk = data.companyId === "RAY90001" ? `type:package:sqa` : `type:package`;
    const payload = {
        type: "query",
        region: "ap-northeast-2",
        params: {
            TableName: "rayteams-license",
            KeyConditionExpression: "#_id = :_id and #sk = :sk",
            ExpressionAttributeNames: {
                "#_id": "_id",
                "#sk": "sk"
            },
            ExpressionAttributeValues: {
                ":_id": CTSegmentation.appId,
                ":sk": sk
            }
        }
    }
    const list = await DoDB(payload.type, payload.params);
    return list[0] ?? [];
};

const ProductChangeSN = async (data) => {
    const bodyData = {
        reason: data.reason,
        user: data?.user,
        who: data?.user,
        type: data?.type || "",
    };
    try {
        const ret = await axios.post(RG_RELU_API + `/prdtype/${data.sn.toUpperCase()}/${data.prdtype}`, bodyData, JWT());
        return ret.data;
    } catch (error) {
        // IMP-091 §7: 관측성 추가하되 호출처 abort 의미 보존을 위해 re-throw
        console.warn('[LicenseAction.ProductChangeSN] failed', {
            handler: 'LicenseAction.ProductChangeSN',
            target: data?.sn,
            reason: error?.message || String(error),
        });
        throw error;
    }
}

// Resolve a companyId (from the logged-in user) to the enclosing manager
// group's _id. Scans rayteams-manager-group for a record whose companyIds
// array contains the given companyId and returns the first match's _id.
//
// When no record contains the given companyId directly, the logged-in user
// is likely sitting on a branch that is not itself the one attached to the
// manager group — walk up via getParents(companyHierarchyService) to find the owning
// Branch company, then rescan. Mirrors the branch-resolution fallback in
// GetLicenseByCompanyId.
//
// Returns null when both attempts miss.
const GetManagerGroupIdByCompanyId = async (companyId) => {
    try {
        const scanByCompany = (targetCompanyId) =>
            DoDB('scan', {
                TableName: 'rayteams-manager-group',
                FilterExpression: 'contains(#companyIds, :companyId)',
                ExpressionAttributeNames: { '#companyIds': 'companyIds' },
                ExpressionAttributeValues: { ':companyId': targetCompanyId },
            });

        const direct = await scanByCompany(companyId);
        if (direct?.length > 0) return direct[0]._id;

        const parentCompanyId = await getParents();
        let resolvedCompanyId;
        if (parentCompanyId.length === 1 && parentCompanyId[0].code === companyId) {
            resolvedCompanyId = companyId;
        } else {
            resolvedCompanyId = parentCompanyId.find(
                (x) => x.code !== companyId && x?.org === 'Branch' && isRootCompany(x),
            )?.code;
        }
        if (!resolvedCompanyId) return null;

        const fallback = await scanByCompany(resolvedCompanyId);
        return fallback?.[0]?._id ?? null;
    } catch (error) {
        console.error('[LicenseAction.GetManagerGroupIdByCompanyId]', error);
        return null;
    }
};

export const LicenseAction = {
    Create,
    Modify,
    GetAll,
    SearchByLanguage,
    SearchByLanguageDirect,
    GetLicenseBySN,
    GetManagerGroupInfoByCompanyId,
    GetManagerGroupIdByCompanyId,
    GetManagerGroupLicenseType,
    CheckFireStoreSN,
    UpdateFireStoreTask,
    UpdateLicenseCount,
    UpdateLicenseSN,
    GetLicenseSN,
    CreateLicenseSN,
    CreateReluLicenseSN,
    GetLicenseByCompanyId,
    GetReluLicenseInfo,
    ProductChangeSN,
    ChangeLicenseSN,
    GetALLLicenseSN
};
